import { colors } from '#base/js/variables.style'

export function getStyle ({
  color = 'white',
  background = 'var(--theme-brand-alt)'
} = {}) {
  return {
    arrow: {
      sx: {
        color: background
      }
    },
    tooltip: {
      sx: {
        margin: '10px',
        padding: '10px',
        background,
        color,
        fontSize: '13px',
        borderRadius: '8px'
      }
    }
  }
}

export const styles = {
  default: getStyle({
    background: 'var(--theme-brand-alt)'
  }),
  error: getStyle({
    background: 'var(--theme-status-error)'
  }),
  info: getStyle({
    background: 'var(--theme-status-info)'
  }),
  success: getStyle({
    background: 'var(--theme-status-success)'
  }),
  pending: getStyle({
    color: 'black',
    background: 'var(--theme-brand-yellow)'
  }),
  warning: getStyle({
    background: 'var(--theme-status-warning)'
  })
}
